'use client';

import { useEffect } from 'react';

const jornayaCampainToken = '35ac6b7c-9870-e699-311c-be197bfe5aa4';

const JornayaComponent = () => {
  useEffect(() => {
    if (!document.getElementById('LeadiDscript_campaign')) {
      const script = document.createElement('script');
      script.id = 'LeadiDscript_campaign';
      script.src = `https://create.lidstatic.com/campaign/${jornayaCampainToken}.js?snippet_version=2&f=reset`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return null;
};

export default JornayaComponent;
